// extracted by mini-css-extract-plugin
export default {"recentlyPlayed":"RecentlyPlayed_recentlyPlayed__H2-zm","title":"RecentlyPlayed_title__OHHS0"};